// extracted by mini-css-extract-plugin
export default {"content":"styles_content__dRKuJ","contentheader":"styles_contentheader__vPfZX","logo":"styles_logo__1AyGX"};